module.exports = __webpack_public_path__ + "static/ftrs-about-us-0295a1810322a60534461799cb965907.mp4";